<template>
  <a-layout class="s_bf">
    <a-card :bordered="false">
      <a-form ref="ruleForm" :rules="rules" :model="form" :label-col="labelCol" :wrapper-col="wrapperCol" :scrollToFirstError="true">
        <a-form-item ref="activity_name" label="活动名称" name="activity_name" required>
          <a-input v-model:value="form.activity_name" placeholder='请输入活动名称' style="width:300px"></a-input>
        </a-form-item>
        <a-form-item label="活动时间" name='end_time' required help='活动时间需与活动宣传的活动规则保持一致'>
          <a-range-picker v-model:value="time" :show-time="{ format: 'YYYY-MM-DD HH:mm' }" style="width:300px" valueFormat='YYYY-MM-DD HH:mm:ss' format='YYYY-MM-DD HH:mm:ss' @change="onChange" />
        </a-form-item>
        <!-- 1'普通模板':2'云店模板'3'溯源模板' 4'会员卡模板’ -->
        <a-form-item label="扫码模板" name='template_uuid' required>
          <a-row :gutter="16">
            <a-col :span="9">
              <a-input readonly placeholder='请选择关联模板' v-model:value="form.template_name" />
            </a-col>
            <a-col :span="8">
              <a-button type="primary" @click="templateVisible=true">选择</a-button>
            </a-col>
          </a-row>
        </a-form-item>
        <a-form-item label="发放会员卡" name='template_uuid' required>
          <a-row :gutter="16">
            <a-col :span="9">
              <a-input readonly placeholder='请选择关联模板' v-model:value="form.award_rel_text" />
            </a-col>
            <a-col :span="8">
              <a-button type="primary" @click="cardVisible=true">选择会员卡</a-button>
            </a-col>
          </a-row>
        </a-form-item>
        <a-form-item label="活动规则" name='is_rule'>
          <a-switch :checkedValue="1" :unCheckedValue="0" v-model:checked="form.is_rule" />
        </a-form-item>
        <a-form-item label="规则标题" name='rule_title' v-if="form.is_rule">
          <a-input v-model:value="form.rule_title" placeholder='请输入规则标题' style="width:300px"></a-input>
        </a-form-item>
        <a-form-item label="规则内容" name='rule_content' required v-if="form.is_rule">
          <quill v-model:value="form.rule_content" :content="form.rule_content" />
        </a-form-item>
        <a-form-item label="资料收集" :wrapper-col="{span:20}" style="margin-bottom: 20;">
          <a-switch :checkedValue="1" :unCheckedValue="0" v-model:checked="form.is_open_collect_data"></a-switch>
          <a-tooltip placement='right'>

            <template #title>开启资料收集可能会被投诉停止访问，请谨慎开启，详情见 “<a href="http://weixin.qq.com/cgi-bin/readtemplate?t=weixin_external_links_content_management_specification" style="color: #2aae67;" target="_blank">微信新规</a>”
            </template>
            <InfoCircleOutlined class="m-l-10" />
          </a-tooltip>
          <div v-if="form.is_open_collect_data">
            <a-form-item label="条件设置" name="collect_data_second">
              第
              <a-input-number class="m-l-5 m-r-5" :min="1" :max="100" :precision="0" v-model:value="form.collect_data_second" disabled /> 次扫码领奖时收集用户资料 <a-tooltip placement='right'>
                <template #title>过该策略可以实现指定用户发奖、指定地区发奖、指定时间段发奖等功能，实现精准营销
                </template>
                <InfoCircleOutlined />
              </a-tooltip>
            </a-form-item>
            <a-form-item label="收集字段" required>
              <a-checkbox-group v-model:value="form.customize_id">
                <template v-for="v in custimizesList" :key="v.id">
                  <a-checkbox :value="String(v.id)" :checked="v.is_select">{{v.customize_name}}</a-checkbox>
                </template>
              </a-checkbox-group>
              <a href="javascript:;" @click="visible=true">新增自定义字段</a>
            </a-form-item>
          </div>
        </a-form-item>

        <a-form-item label="活动备注" name='remarks'>
          <a-textarea v-model:value="form.remarks" placeholder='请输入活动备注' showCount :maxlength="50" style="width:300px" />
        </a-form-item>
        <a-button type="primary" @click="next()" class="marigin_lr_auto">下一步</a-button>
      </a-form>
    </a-card>
    <a-modal title="选择模板" :keyboard="false" v-model:visible="templateVisible" centered :width='1200' :footer="null" destroyOnClose v-if="templateVisible">
      <selectTemplate v-on:success="templateHandle" v-if="templateVisible"  :template_type="5" />
    </a-modal>
    <!--资料收集 -->
    <a-modal :keyboard="false" v-model:visible="visible" title="字段列表" centered style="width:700px;" :width='1000' @ok="getcustimizesList();visible=false" destroyOnClose>
      <custimizes />
    </a-modal>
    <a-modal title="选择会员卡" :keyboard="false" v-model:visible="cardVisible" centered :width='1200' :footer="null" destroyOnClose v-if="cardVisible">
      <selectCard :selectList="[]" :checkout="false" v-on:select="cardSelect" />
    </a-modal>
  </a-layout>
</template>

<script>
import {
  activitysOneCreate,
  activitysOneDetail,
  activitysOneUpdate,
  activitysFourCustomizesSelectList,
} from "@/api/qrcodeActivitys";
import { inject, onMounted, provide, reactive, ref, toRefs } from "vue";
import { iscode } from "@/utils/app";
import { message } from "ant-design-vue";
import custimizes from "../custimizes";
const labelCol = { span: 3 };
const wrapperCol = { span: 12 };
const def = {
  activity_name: "",
  activity_type: 2, //先写死 活动类型  领取会员卡活动
  start_time: "",
  end_time: "",
  template_uuid: "",
  is_rule: false,
  rule_title: "",
  rule_content: "",
  remarks: "",
  template_name: "",
  collect_data_second: 1,
  award_rel_text:'',
  award_rel_id:'',
  award_type:2,
  is_open_collect_data: false,
};
const rules = {
  activity_name: [
    {
      required: true,
      message: "请输入活动名称",
    },
  ],
  template_uuid: [
    {
      required: true,
      message: "请选择模板",
    },
  ],
  end_time: [
    {
      required: true,
      message: "请选择活动时间",
    },
  ],
  rule_content: [
    {
      required: true,
      message: "请输入规则内容",
    },
  ],
  rule_title: [
    {
      required: true,
      message: "请输入规则标题",
    },
  ],
};
export default {
  props: {
    activity_id: {
      type: Number,
      default: () => {
        return null;
      },
    },
  },
  components: { custimizes },
  setup(props, { emit }) {
    const state = reactive({
      visible: false,
      cardVisible: false, //会员卡选择
    });
    const momentTime = inject("momentTime");
    const form = ref(def);
    const time = ref(null);
    const ruleForm = ref();
    // 修改时间
    const onChange = (e) => {
      form.value.start_time = e[0];
      form.value.end_time = e[1];
    };
    // 获取详情
    const detail = async () => {
      let result = await activitysOneDetail(props.activity_id)
        .then((res) => res.data)
        .catch((error) => error);
      if (iscode(result)) {
        form.value = result.data;
        time.value = [result.data.start_time, result.data.end_time];
        emit("template_type", form.value.template_type);
      } else {
        message.error(result.message);
      }
    };
    // 下一步
    const next = () => {
      if (props.activity_id) {
        update();
      } else {
        create();
      }
    };
    // 创建
    const create = () => {
      ruleForm.value.validate().then(async (res) => {
        let result = await activitysOneCreate({
          ...form.value,
          start_time: form.value.start_time,
          end_time: form.value.end_time,
        })
          .then((res) => res.data)
          .catch((error) => error);
        if (iscode(result, true)) {
          emit("setpsOneDone", {
            ...form.value,
            activity_id: result.data.activity_id,
          });
        }
      });
    };
    // 修改
    const update = () => {
      ruleForm.value.validate().then(async (res) => { 
        let result = await activitysOneUpdate(props.activity_id, {...form.value,activity_type:2})
          .then((res) => res.data)
          .catch((error) => error);
        if (iscode(result, true)) {
          emit("setpsOneDone", {
            ...form.value,
            activity_id: result.data.activity_id,
          });
        }
      });
    };
    // 选择模板
    const templateVisible = ref(false);
    const templateHandle = (data) => {
      form.value.template_uuid = data.template_uuid;
      form.value.template_name = data.name;
      form.value.template_type = data.type;
      console.log(data.type);
      emit("template_type", data.type);
      templateVisible.value = false;
    };
    // 资料收集
    const custimizesList = ref([]);
    const getcustimizesList = async () => {
      let result = await activitysFourCustomizesSelectList(props.activity_id||0)
        .then((res) => res.data)
        .catch((error) => error);
      if (iscode(result)) {
        custimizesList.value = result.data;
        console.log(custimizesList.value);
      }
    };

    // 选择会员卡
    const cardSelect = (data) => {
      form.value.award_rel_id=data.vip_id
      form.value.award_rel_text=data.vip_name
      state.cardVisible = false;
    };
    onMounted(() => {
      getcustimizesList();
    });
    return {
      form,
      custimizesList,
      rules,
      ruleForm,
      time,
      labelCol,
      wrapperCol,
      onChange,
      create,
      update,
      detail,
      next,
      templateHandle,
      templateVisible,
      ...toRefs(state),
      cardSelect,
      getcustimizesList
    };
  },
};
</script>